// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/arrow-prev.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/arrow-next.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider {
  width: 100%;
}

.slider__gallery {
  display: flex;
  overflow: hidden;
  width: 100%;
}

.slider__image-container {
  width: 455px;
  height: 460px;
  border: 10px solid white;
  box-sizing: border-box;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  margin-right: 7px;
  flex-shrink: 0;
}

.slider__image-container:last-of-type {
  margin-right: 0;
}

.slider__image {
  width: 100%;
  height: auto;
  max-height: 98%;
  border-radius: 5px;
}

.slider__button-container {
  max-width: fit-content;
  display: flex;
  margin: 0 0 80px auto;
}

.slider__button {
  background-color: unset;
  border: none;
  width: 60px;
  height: 37px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 0.3s;
}

.slider__button:hover {
  opacity: 0.7;
}

.slider__prev {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  margin: 0 43px 0 0;
}

.slider__next {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.slider__dot-bar {
  width: fit-content;
  display: flex;
  margin: 20px auto 0 auto;
  padding: 0;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.slider__dot {
  width: 15px;
  height: 15px;
  background-color: white;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s;
}

.slider__dot:hover {
  opacity: 0.7;
}

.slider__dot_active {
  background-color: rgba(184, 166, 155, 0.7);
  width: 18px;
  height: 18px;
}

@media screen and (max-width: 1439px) {
  .slider__image-container {
    width: 322px;
    height: 322px;
  }
}

@media screen and (max-width: 1023px) {
  .slider__image-container {
    width: 350px;
    height: 350px;
  }

  .slider__button-container {
    margin: 0 0 40px auto;
  }
}

@media screen and (max-width: 763px) {
  .slider {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .slider__gallery {
    margin: 0 0 61px 0;
  }

  .slider__image-container {
    width: 320px;
    height: 320px;
    border: 5px solid white;
    padding: 5px;
    margin-right: 0;
    flex-shrink: 0;
  }

  .slider__button-container {
    margin: 0 auto 20px auto;
  }

  .slider__prev {
    margin: 0 50px 0 0;
  }

  .slider__dot-bar {
    margin: 20px auto 0 auto;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ImageSlider/ImageSlider.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,yDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,UAAU;EACV,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,SAAS;EACX;AACF","sourcesContent":[".slider {\r\n  width: 100%;\r\n}\r\n\r\n.slider__gallery {\r\n  display: flex;\r\n  overflow: hidden;\r\n  width: 100%;\r\n}\r\n\r\n.slider__image-container {\r\n  width: 455px;\r\n  height: 460px;\r\n  border: 10px solid white;\r\n  box-sizing: border-box;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 10px;\r\n  margin-right: 7px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.slider__image-container:last-of-type {\r\n  margin-right: 0;\r\n}\r\n\r\n.slider__image {\r\n  width: 100%;\r\n  height: auto;\r\n  max-height: 98%;\r\n  border-radius: 5px;\r\n}\r\n\r\n.slider__button-container {\r\n  max-width: fit-content;\r\n  display: flex;\r\n  margin: 0 0 80px auto;\r\n}\r\n\r\n.slider__button {\r\n  background-color: unset;\r\n  border: none;\r\n  width: 60px;\r\n  height: 37px;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.slider__button:hover {\r\n  opacity: 0.7;\r\n}\r\n\r\n.slider__prev {\r\n  background-image: url(\"../../images/arrow-prev.svg\");\r\n  margin: 0 43px 0 0;\r\n}\r\n\r\n.slider__next {\r\n  background-image: url(\"../../images/arrow-next.svg\");\r\n}\r\n\r\n.slider__dot-bar {\r\n  width: fit-content;\r\n  display: flex;\r\n  margin: 20px auto 0 auto;\r\n  padding: 0;\r\n  gap: 8px;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.slider__dot {\r\n  width: 15px;\r\n  height: 15px;\r\n  background-color: white;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.slider__dot:hover {\r\n  opacity: 0.7;\r\n}\r\n\r\n.slider__dot_active {\r\n  background-color: rgba(184, 166, 155, 0.7);\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n@media screen and (max-width: 1439px) {\r\n  .slider__image-container {\r\n    width: 322px;\r\n    height: 322px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1023px) {\r\n  .slider__image-container {\r\n    width: 350px;\r\n    height: 350px;\r\n  }\r\n\r\n  .slider__button-container {\r\n    margin: 0 0 40px auto;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 763px) {\r\n  .slider {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .slider__gallery {\r\n    margin: 0 0 61px 0;\r\n  }\r\n\r\n  .slider__image-container {\r\n    width: 320px;\r\n    height: 320px;\r\n    border: 5px solid white;\r\n    padding: 5px;\r\n    margin-right: 0;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .slider__button-container {\r\n    margin: 0 auto 20px auto;\r\n  }\r\n\r\n  .slider__prev {\r\n    margin: 0 50px 0 0;\r\n  }\r\n\r\n  .slider__dot-bar {\r\n    margin: 20px auto 0 auto;\r\n    gap: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
